import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import { Link } from 'react-router-dom'
import { Row, Col, Button } from 'reactstrap'
import axios from 'axios'
import moment from 'moment'

import ContentWrapper from '../../Layout/ContentWrapper'

class SalaryCalculations extends Component {
  constructor() {
    super()
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    this.axiosCancelSource = axios.CancelToken.source()
    axios
      .get(`salarycalculations`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data
          })
        }
      })
      .catch((error) => {})
  }

  componentWillUnmount() {
    this.axiosCancelSource.cancel('Component unmounted')
  }

  render() {
    const columns = [
      {
        name: 'Emri',
        label: 'Emri',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Pershkrimi',
        label: 'Përshkrimi',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Krijuar nga',
        label: 'Krijuar nga',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Modifikuar nga',
        label: 'Modifikuar nga',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Data e modifikimit',
        label: 'Data e Modifikimit',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Modifiko',
        label: 'Modifiko',
        options: {
          filter: true,
          sort: true
        }
      }
    ]
    const options = {
      responsive: 'scroll',
      filterType: 'dropdown',
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: 'Nuk ka të dhëna'
        }
      }
    }

    const data = this.state.data.map((element) => {
      return [
        element.name,
        element.description,
        element.created_by.email,
        element.edited_by && element.edited_by.email,
        element.last_edit_date && moment(element.last_edit_date).format('DD/MM/YYYY'),
        <Link to={`/editSalaryMethod/${element._id}`}>
          <Button outline className='mb-1' color='warning' type='button'>
            <span>Modifiko</span>
          </Button>
        </Link>
      ]
    })

    return (
      <ContentWrapper>
        <div className='content-heading'>
          <div>Metodat e kalkulimit te pagave</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
            className='ml-auto'
          >
            <Link to='/editSalaryMethod'>
              <Button color='success' className='btn-oval'>
                Shto Metodë
              </Button>
            </Link>
          </div>
        </div>
        <Row>
          <Col>
            <MUIDataTable title={'Metodat'} columns={columns} options={options} data={data} />
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default SalaryCalculations
